module.exports = __webpack_public_path__ + "static/media/bird-silky-chicken2.3074f112.aac";